import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

interface Props {
  open: boolean;
  remainingMs: number;
  onStay: () => void;
  onLogout: () => void;
}

/**
 * IR-1241 — the inactivity countdown modal. Presentational only; the timers and
 * the refresh live in use-idle-logout. Radix keeps focus trapped here, so the
 * operator must consciously choose Stay signed in or Log out now.
 */
export function IdleWarningDialog({ open, remainingMs, onStay, onLogout }: Props) {
  const seconds = Math.ceil(Math.max(0, remainingMs) / 1000);
  return (
    <Dialog open={open}>
      <DialogContent
        style={{ display: "flex", flexDirection: "column", gap: 16, padding: 20, maxWidth: 420 }}
        // Not dismissible by Esc / outside-click — a stray keypress must not be
        // read as "keep me signed in".
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogTitle>Are you still there?</DialogTitle>
        <DialogDescription>
          For your security, Iris Ops will sign you out in{" "}
          <strong>
            {seconds} second{seconds === 1 ? "" : "s"}
          </strong>{" "}
          due to inactivity.
        </DialogDescription>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button type="button" className="iris-btn" onClick={onLogout}>
            Log out now
          </button>
          <button type="button" className="iris-btn iris-btn--primary" onClick={onStay}>
            Stay signed in
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
